import { map, omit } from 'lodash-es';
import { unparse } from 'papaparse';
import type { ISecodaEntity } from '../../api';

export function generateCsvFromResults(
	results: Record<string, unknown>[],
	customProperties?: { id: string; name: string }[]
): string {
	const csv = unparse(
		map(results, (el) => {
			const normalized = { ...el } as Record<string, unknown>;

			const propertyNameMap =
				customProperties?.reduce(
					(acc, cp) => {
						// eslint-disable-next-line no-param-reassign
						acc[cp.id] = cp.name;
						return acc;
					},
					{} as Record<string, string>
				) ?? {};

			Object.values(propertyNameMap).forEach((name) => {
				normalized[name] = '';
			});

			Object.keys(normalized).forEach((key) => {
				if (
					key === 'properties2' &&
					(normalized as unknown as ISecodaEntity)[key]
				) {
					try {
						const properties =
							typeof normalized[key] === 'string'
								? JSON.parse(normalized[key])
								: normalized[key];

						delete normalized[key];

						Object.entries(properties).forEach(([uuid, value]) => {
							const columnName = propertyNameMap[uuid] ?? uuid;
							normalized[columnName] =
								Array.isArray(value) || typeof value === 'object'
									? JSON.stringify(value)
									: value;
						});
					} catch (e) {
						// eslint-disable-next-line no-console
						console.warn('Failed to parse properties2 field', e);
					}
				}
			});

			if ('owners_display' in normalized) {
				normalized['owners'] = normalized['owners_display'];
				delete normalized['owners_display'];
			}
			if ('subscribers_display' in normalized) {
				normalized['subscribers'] = normalized['subscribers_display'];
				delete normalized['subscribers_display'];
			}
			if ('tags_display' in normalized) {
				normalized['tags'] = normalized['tags_display'];
				delete normalized['tags_display'];
			}
			if ('related_resources_display' in normalized) {
				normalized['related_resources'] =
					normalized['related_resources_display'];
				delete normalized['related_resources_display'];
			}

			return omit(normalized, [
				'display_metadata',
				'properties',
				'properties2',
				'custom_backup',
				'search_metadata',
				'credentials',
				'last_error_message',
				'schedule',
				'last_measurement',
			]);
		}),
		{
			escapeFormulae: true,
		}
	);

	return csv;
}
